// extracted by mini-css-extract-plugin
export default {"container":"Home_container__HLpTt","bg":"Home_bg__ms2Lg","info":"Home_info__mozAZ"};